import axios from 'axios';
import vueStore from '../store/store.js';

var cartMixin = {
    created() {

    },
    methods: {
        getCartSummary(expanded, success) {
            if (expanded == undefined) {
                expanded = false;
            }
            const cartSummaryUrl = '/' + window.culture + '/shop/getcart?expanded=' + expanded + '&r=' + Math.random() + (window.store != undefined && window.store.length > 0 ? '&store=' + window.store : '') + ('&divisionCode=' + window.divisionCode);

            axios.get(cartSummaryUrl)
                .then(function (response) {
                    if (response && response.data) {
                        vueStore.commit('setCart', response.data)
                        if (success != undefined) {
                            success(response);
                        }
                    }
                })
        },
        addCartItem(partnumberCode, productId, productTypeId, product, partnumber, callbackSuccess, callbackException) { //product and partnumber are used for bundles and add-ons

            window.log("--- addCartItem ---");

            var _product = product;
            if (_product == null) {
                _product = this.product;
            }
            this._product = _product;

            var _partnumber = partnumber;
            if (_partnumber == null) {
                _partnumber = this.partnumber;
            }

            //indien bundle item. Eerst controleren of parent product is toegevoegd
            var prod = vueStore.state.product;
            if (prod.Product.Id != productId) {
                var productIdToCheck = prod.Product.Id;
                // SK+BB 29-08-2024 alle jezus grote tyfus bug fix
                if (prod.Product.ProductType == 2) {
                    productIdToCheck = prod.Product.GearGlobalProductId;
                }
                //in dit geval wordt er een bundle toegevoegd
                if (this.hasProductInCart(productIdToCheck) == false && callbackException) {
                    // parent product nog niet toegevoegd
                    callbackException(this.getInterfaceText('shop_bundle_item_no_parent_added_exception'));
                    return;
                }
            }

            if (_product != null && _partnumber != null && _partnumber.Code != '' && productId > 0 && productTypeId > 0) {
                vueStore.commit('setAddingProductToCart', true);
                event.currentTarget.classList.add("btn-run-progress");

                var cartItem = {
                    productId: 0,
                    partnumberCode: '',
                    productType: 0,
                    quantity: 0,
                    dealerCode: '',
                    globalCatalogue: true,
                    GAclientId: ''
                };

                // populate cart item object
                cartItem.partnumberCode = _partnumber.code;
                cartItem.productId = productId;
                cartItem.productType = productTypeId;
                cartItem.quantity = 1;
                cartItem.globalCatalogue = true;
                cartItem.GAclientId = this.GAclientId;
                // add dealer when selected
                if (this.selectedDealer && this.selectedDealer.Code) {
                    cartItem.dealerCode = this.selectedDealer.Code;
                }
                if (this.shippingOption && this.shippingOption.Id) {
                    cartItem.shippingOptionId = this.shippingOption.Id;
                }

                var supplementaryItem = vueStore.state.supplementaryItem;
                if (supplementaryItem && supplementaryItem.code) {
                    cartItem.supplementaryItemPartnumberCode = supplementaryItem.code;
                }

                this.exceptionMessageCart = '';
                var that = this;
                var current = event.currentTarget;

                // api url
                var url = '/' + window.culture + '/shop/addcartitem' + (window.store != undefined && window.store.length > 0 ? '?store=' + window.store : '');
                // post
                axios({
                    method: "post",
                    url: url,
                    data: cartItem
                })
                    .then(function (response) {
                        //handle success
                        if (response.data.result > 0) {

                            // Fire the getCartSummary first to update the cartSummary
                            that.getCartSummary(null, function () {// remove progress
                                current.classList.remove("btn-run-progress");

                                if (that._product != null) {
                                    //GA4
                                    var items = [];
                                    items.push({
                                        'item_id': that._product.ProductType == 3 ? 'giftcard-' + that._product.PriceOriginal : (that._product.ProductType == 1 ? 'bikemodel-' : 'gearproduct-') + that._product.Id.toString(),
                                        'item_name': that._product.Name != undefined ? that._product.Name.toLowerCase() : that._product.ProductType == 3 ? 'digital gift card or tradeup voucher' : '',
                                        'discount': _partnumber.priceOriginal > 0 ? _partnumber.priceOriginal - _partnumber.price : 0,
                                        'index': 1,
                                        'item_brand': that._product.BrandName.toLowerCase(),
                                        'item_category': that._product._pagecategory != undefined && that._product._pagecategory.length > 0 ? that._product._pagecategory[0].GA_label.toLowerCase() : 'n/a',
                                        'item_category2': that._product._pagecategory != undefined && that._product._pagecategory.length > 1 ? that._product._pagecategory[1].GA_label.toLowerCase() : 'n/a',
                                        'item_category3': that._product._pagecategory != undefined && that._product._pagecategory.length > 2 ? that._product._pagecategory[2].GA_label.toLowerCase() : 'n/a',
                                        'item_variant': (_partnumber.description.trim() + (_partnumber.color != undefined && _partnumber.color.length > 0 ? ' ' + _partnumber.color : '')).toLowerCase(),
                                        'price': _partnumber.priceOriginal,
                                        'quantity': 1
                                    });
                                    window.trackEventGlobalAndLocalGA4({
                                        'ga4_name': 'add_to_cart',
                                        'ga4_currency': window.currencyCode,
                                        'ga4_value': _partnumber.price,
                                        'ga4_items': items
                                    });


                                    //post to Facebook
                                    try {
                                        var preferences = window.$.gdprcookie.preference();
                                        if (preferences.indexOf('marketing') > -1) {
                                            window.fbq('track', 'AddToCart', {
                                                content_name: that._product.Name,
                                                content_ids: [_partnumber.code],
                                                content_type: 'product',
                                                value: _partnumber.price,
                                                currency: window.currencyCode
                                            });
                                        }
                                    } catch (e) {
                                        window.log(e);
                                    }

                                    //post to Klaviyo
                                    try {
                                        if (window.klaviyo != undefined) {
                                            var _cartitems = [];
                                            if (that.Cart.CartItems != undefined) {
                                                for (var i = 0; i < that.Cart.CartItems.length; i++) {
                                                    var cartItem = that.Cart.CartItems[i];
                                                    var item = {
                                                        "ProductID": cartItem.Product.Id,
                                                        "SKU": cartItem.Product.Partnumber.Code,
                                                        "ProductName": cartItem.Product.Name,
                                                        "Quantity": cartItem.Quantity,
                                                        "ItemPrice": cartItem.Product.Partnumber._price,
                                                        "RowTotal": cartItem.Total,
                                                        "ProductURL": cartItem.Product.UrlLabel,
                                                        "ImageURL": cartItem.Product.ImageBig,
                                                    };
                                                    _cartitems.push(item);
                                                }
                                            }
                                            window.klaviyo.push(["track", "Added to Cart", {
                                                "$value": _partnumber.price,
                                                "AddedItemProductName": that._product.Name,
                                                "AddedItemProductID": that._product.Id,
                                                "AddedItemSKU": partnumberCode,
                                                "AddedItemImageURL": that._product.Image,
                                                "AddedItemURL": window.masterDomain + '/' + window.culture + '/' + that._product.UrlLabel,
                                                "AddedItemPrice": _partnumber.price,
                                                "AddedItemQuantity": 1,
                                                "CheckoutURL": window.masterDomain + '/' + window.culture + '/shop/review',
                                                "Items": _cartitems
                                            }]);
                                            window.log('klaviyo sent Added to Cart');
                                        }
                                    } catch (e) {
                                        window.log(e);
                                    }
                                }

                                if (callbackSuccess) {
                                    callbackSuccess();
                                }
                            });

                            // get item
                            if (that._product != null) {
                                var addedItem = that._product.Partnumbers?.find(x => x.code == _partnumber.code);
                                if (addedItem) {
                                    addedItem.hasBeenAddedToCart = true;
                                }
                            }

                        } else {
                            //angular.element('#cartModalError').modal('show');
                            that.exceptionMessageCart = response.data.exceptionmessage;
                            // remove progress
                            current.classList.remove("btn-run-progress");

                            if (callbackException) {
                                callbackException(response.data.exceptionmessage);
                            }
                        }
                    })
                    .catch(function (response) {
                        //handle error
                        that.exceptionMessageCart = response;
                        current.classList.remove("btn-run-progress");
                    })

            } else {
                alert("addCartItem is missing data");
            }
        },
        setCartItemQuantity(item, event) {
            var newQuantity = event.target.value;
            var quantityToAddOrSubtract = newQuantity - item.Quantity;
            this.updateCartItem(item, quantityToAddOrSubtract);
        },
        updateCartItem(item, quantity) {
            if (this.CartInProgress == false) {
                this.ToggleCartInProgress();
                const updateCartUrl = '/' + window.culture + '/shop/updatecartitem' + (window.store != undefined && window.store.length > 0 ? '?store=' + window.store : '')
                const data = {
                    partnumberCode: item.Product.Partnumber.Code,
                    modelId: item.Product.Id,
                    productType: item.Product.ProductTypeId,
                    quantity: quantity,
                    SupplementaryItemPartnumberCode: (item.SupplementaryItemPartnumberCode != null ? item.SupplementaryItemPartnumberCode : '')
                }
                const config = {
                    transformRequest: [function (data) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in data)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
                        return str.join("&");
                    }],
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                }

                var that = this;
                axios.post(updateCartUrl, data, config)
                    .then(function (response) {
                        if (response && response.data) {
                            vueStore.commit('setCart', response.data)
                        }

                        //GA4
                        var items = [];
                        items.push({
                            'item_id': (item.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + item.Product.GA_ProductId.toString(),
                            'item_name': item.Product.Name.toLowerCase(),
                            'discount': item.Product.PriceOriginal > 0 ? item.Product.PriceOriginal - item.Product.Partnumber._price : 0,
                            'index': 1,
                            'item_brand': item.Product.BrandName.toLowerCase(),
                            'item_category': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 0 ? item.Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                            'item_category2': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 1 ? item.Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                            'item_category3': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 2 ? item.Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                            /*'item_list_id': '$item_list_id',*/
                            /*'item_list_name': $scope.modelcategory,*/
                            'item_variant': (item.Product.Partnumber.Size + (item.Product.Partnumber.Color != undefined && item.Product.Partnumber.Color.length > 0 ? ' ' + item.Product.Partnumber.Color : '')).toLowerCase(),
                            'price': item.Product.PriceOriginal,
                            'quantity': 1
                        });
                        window.trackEventGlobalAndLocalGA4({
                            'ga4_name': quantity == -1 ? 'remove_from_cart' : 'add_to_cart',
                            'ga4_currency': window.currencyCode,
                            'ga4_value': item.Product.Partnumber._price,
                            'ga4_items': items
                        });

                        that.ToggleCartInProgress();
                    })
            }
        },

        removeCartItem(item) {
            if (this.CartInProgress == false) {
                this.ToggleCartInProgress();
                const removeCartItemUrl = '/' + window.culture + '/shop/removecartitem/' + item.Id + '/json?r=' + Math.random() + (window.store != undefined && window.store.length > 0 ? '&store=' + window.store : '') + (item.SupplementaryItemPartnumberCode != null ? '&SupplementaryItemPartnumberCode=' + item.SupplementaryItemPartnumberCode : '')

                var that = this;
                axios.get(removeCartItemUrl)
                    .then(function (response) {
                        if (response && response.data) {
                            vueStore.commit('setCart', response.data)

                            //GA4
                            var items = [];
                            items.push({
                                'item_id': (item.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + item.Product.Id.toString(),
                                'item_name': item.Product.Name.toLowerCase(),
                                'discount': item.Product.PriceOriginal > 0 ? item.Product.PriceOriginal - item.Product.Partnumber._price : 0,
                                'index': 1,
                                'item_brand': item.Product.BrandName.toLowerCase(),
                                'item_category': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 0 ? item.Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                                'item_category2': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 1 ? item.Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                                'item_category3': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 2 ? item.Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                                /*'item_list_name': item.Product.GA_Category,*/
                                'item_variant': (item.Product.Partnumber.Size + (item.Product.Partnumber.Color != undefined && item.Product.Partnumber.Color.length > 0 ? ' ' + item.Product.Partnumber.Color : '')).toLowerCase(),
                                'price': item.Product.PriceOriginal,
                                'quantity': 1
                            });
                            window.trackEventGlobalAndLocalGA4({
                                'ga4_name': 'remove_from_cart',
                                'ga4_currency': window.currencyCode,
                                'ga4_value': item.Product.Partnumber != undefined ? item.Product.Partnumber._price : item.Product.PriceOriginal != undefined ? item.Product.PriceOriginal : '',
                                'ga4_items': items
                            });

                            that.ToggleCartInProgress();
                        }
                    })
            }
        },
        removePartnumberFromCart(partnumbercode) {
            //get cartItem by partnumbercode located in addon.
            if (vueStore.state.cart && vueStore.state.cart.CartItems) {
                var cartItem = vueStore.state.cart.CartItems.filter(x => x.Product.Partnumber.Code == partnumbercode);
                if (cartItem.length > 0) {
                    this.removeCartItem(cartItem[0]);
                }
            }
        },
        hasProductInCart(productId) {
            if (vueStore.state.cart && vueStore.state.cart.CartItems) {
                return vueStore.state.cart.CartItems.findIndex(function (cartItem) {
                    return cartItem.Product.Id == productId;
                }) > -1
            }
            return false;
        },
        hasPartnumberInCart(partnumberCode) {
            if (vueStore.state.cart && vueStore.state.cart.CartItems) {
                return vueStore.state.cart.CartItems.findIndex(function (cartItem) {
                    return cartItem.Product.Partnumber.Code == partnumberCode;
                }) > -1
            }
            return false;
        },
        animateAddOn(event) {
            window.log("animate add on");

            try {

                // get start position and size
                var itemDiv = event.target.parentElement.parentElement;
                var itemTop = itemDiv.offsetTop;
                var itemWidth = itemDiv.offsetWidth;
                var containerOffsets = document.getElementById("vue-product-selector").getBoundingClientRect();
                var containerLeft = containerOffsets.left - 30;

                // image
                // itemDiv.classList.add("clicked");

                // create div and set values
                var divToAnimate = document.createElement("div");
                divToAnimate.setAttribute("class", "div-to-animate");
                divToAnimate.style.left = containerLeft + "px";
                divToAnimate.style.top = itemTop + "px";
                divToAnimate.style.width = itemWidth + "px";

                // append
                document.getElementById("vue-product-configurator").appendChild(divToAnimate);

                // get destination position and size
                var imageWidth = document.getElementById("mainImage").clientWidth;
                var imageHeight = document.getElementById("mainImage").clientHeight;
                var imageContainer = document.getElementById("vue-product-images");
                var newTopPosition = window.pageYOffset + imageContainer.offsetTop - imageHeight;
                var newLeftPosition = imageContainer.offsetLeft;

                // animate
                setTimeout(function () {
                    //change position
                    divToAnimate.style.top = newTopPosition + "px";
                    divToAnimate.style.left = newLeftPosition + "px";
                    divToAnimate.style.width = imageWidth + "px";
                    divToAnimate.style.height = imageHeight + "px";

                    // end of animation
                    setTimeout(function () {
                        // fade
                        divToAnimate.style.opacity = "0";
                        // rewmove
                        setTimeout(function () {
                            divToAnimate.remove();
                        }, 1000);

                    }, 1000);
                }, 100);
            }
            catch (err) {
                window.log(err);
            }



        },
        GetGACartItems() {
            var result = [];
            for (var i = 0; i < this.Cart.CartItems.length; i++) {
                var cartItem = this.Cart.CartItems[i];
                var item = {
                    'item_id': cartItem.Product.Partnumber.Code,
                    'item_name': cartItem.Product.Name.toLowerCase(),
                    'item_brand': cartItem.Product.BrandName.toLowerCase(),
                    "item_category": cartItem.Product.GA_Category.toLowerCase(),
                    'item_variant': cartItem.Product.Partnumber != undefined && cartItem.Product.Partnumber.Color.length > 0 ? cartItem.Product.Partnumber.Color : cartItem.Product.Partnumber.Size.length > 0 ? cartItem.Product.Partnumber.Size : '',
                    'quantity': cartItem.Quantity,
                    'price': cartItem.Product.Partnumber._price
                };
                result.push(item);
            }
            return result;
        },
        ToggleCartInProgress() {
            vueStore.commit('setCartInProgress', !this.CartInProgress);
        }
    },
    computed: {
        Cart() {
            return vueStore.state.cart;
        },
        CartInProgress() {
            return vueStore.state.cartInProgress;
        },
        CartHasItems() {
            return (this.Cart?.CartItems?.length || 0) > 0;
        }

    }
}

export default cartMixin;